import type { Arena, ArenaOpponents, Rating, RatingBoard, RatingTop } from '@mezha/api'
import { baseApi } from '../baseApi'

const put = (dispatch: (a: unknown) => unknown, data: Arena) => {
  dispatch(arenaApi.util.upsertQueryData('arena', undefined, data))
  if (data.battle_id) dispatch(baseApi.util.invalidateTags(['ActiveBattle']))
}

export const arenaApi = baseApi.injectEndpoints({
  endpoints: b => ({
    arena: b.query<Arena, void>({ query: () => ({ get: '/api/v1/arena' }), providesTags: ['Arena'] }),
    ratingTop: b.query<RatingTop, RatingBoard>({ query: board => ({ get: `/api/v1/arena/rating/top?board=${board}` }), providesTags: ['Rating'] }),
    ratingMe: b.query<Rating, RatingBoard>({ query: board => ({ get: `/api/v1/arena/rating/me?board=${board}` }), providesTags: ['Rating'] }),
    /** With bots the battle starts at once: the answer carries battle_id. */
    createRequest: b.mutation<Arena, { mode: string; opponents: ArenaOpponents }>({
      query: body => ({ command: '/api/v1/arena/requests', body }),
      onQueryStarted: async (_, { queryFulfilled, dispatch }) => put(dispatch, (await queryFulfilled).data),
    }),
    joinRequest: b.mutation<Arena, { id: string }>({
      query: ({ id }) => ({ command: `/api/v1/arena/requests/${id}/join` }),
      onQueryStarted: async (_, { queryFulfilled, dispatch }) => put(dispatch, (await queryFulfilled).data),
    }),
    cancelRequest: b.mutation<Arena, { id: string }>({
      query: ({ id }) => ({ command: `/api/v1/arena/requests/${id}/cancel` }),
      onQueryStarted: async (_, { queryFulfilled, dispatch }) => put(dispatch, (await queryFulfilled).data),
    }),
  }),
})

export const { useArenaQuery, useRatingTopQuery, useRatingMeQuery, useCreateRequestMutation, useJoinRequestMutation, useCancelRequestMutation } = arenaApi
